import React from 'react';
import ManageUserDetail from '../../../User/manageUserDetails';

export default function ManageUserDetails() {
  return <ManageUserDetail />;
}
